export default {
	fees_payment_receipt: {
		en: "Fees Payment Receipt",
		ar: "سندات رسوم الدائرة",
	},
	receipt_number: {
		en: "Receipt Number",
		ar: "رقم سند القبض",
	},
	receipt_year: {
		en: "Receipt Year",
		ar: " سنة السند",
	},
	receipt: {
		en: "Receipt",
		ar: "سند القبض",
	},
	fees_services: {
		en: "Financial Fees Services",
	},
	fees_receipt_description: {
		en: "You can request fees payment receipt for one of your old procedures like sale, mortgage, map issue,…etc.",
		ar: "يمكنك طلب سند القبض المدفوع لأحد إجراءاتك السابقة مثل البيع، الرهن، إصدار الخارطة،...إلخ",
	},
	send_receipt: {
		en: "Send Receipt",
		ar: "إرسال سند القبض",
	},
	receipt_sent_to_given_email: {
		en: "The receipt is sent to mentioned email address.",
		ar: "تم إرسال السند إلى البريد الإلكتروني",
	},
	fees_refund_request: {
		en: "Fees Refund Request",
		ar: "طلب رد رسوم",
	},
	request_reference_number: {
		en: "Request reference number",
		ar: "الرقم المرجعي",
	},
	refund_amount_request_desc: {
		en: "Please enter the request reference number which you have received via email or SMS.",
		ar: "الرجاء إدخال الرقم المرجعي المرسل إليك عن طريق البريد الإلكتروني أو الهاتف المتحرك",
	},
	track_status_request: {
		en: "Track status of your request",
		ar: "تتبع حالة طلبك",
	},
	amount_to_be_refunded: {
		en: "Amount To Be Refunded",
		ar: "القيمة المطلوب إستردادها",
	},
	refund_reason: {
		en: "Refund Reason",
		ar: " سبب طلب رد الرسوم",
	},
	enter_otp_received_on_mobile_email: {
		en: "Please enter the OTP which you have received via email or SMS.",
		ar: "الرجاء إدخال كلمة المرور المرسلة إليك عن طريق البريد الإلكتروني أو الهاتف المتحرك",
	},
	approval_notes: {
		en: "Approval Notes",
		ar: "ملاحظات الإعتماد",
	},
	request_form: {
		en: "Fee Refund Form",
		ar: "طلب رد رسوم",
	},
	otp_send_to_mob_email_address: {
		en: "We have sent an OTP to the mentioned email address and phone number. Please verify and proceed.",
		ar: "تم إرسال كلمة مرور إلى البريد الإلكتروني و الهاتف المتحرك المسجلين، الرجاء التحقق للمتابعة",
	},
	refund_request_success_msg: {
		en: "Your request is sent for approval, You can track your request in 'Services' menu with option “\Fees Request Refund\"",
		ar: "تم إرسال طلبك للإعتماد، يمكنك متابعة حالة الطلب عن طريق خدمة \"رد الرسوم\" تحت قائمة الخدمات",
	},
};
